import { alias } from '@ember/object/computed';
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import BaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default BaseFragment.extend({
  item: fragment('squareup/inventory/v3/catalog-object-item'),
  itemVariation: fragment('squareup/inventory/v3/catalog-object-item-variation'),
  vendorSKU: attr('string'),
  unitCost: attr('money-proto'),
  catalogVersion: attr('number'),
  isDirty: alias('hasDirtyAttributes'),
  itemVariationToken: alias('itemVariation.token')
});